






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class DeleteViewModal extends Vue {
    @Prop() public value: any;

    get dialog() {
        return this.value;
    }
    
    set dialog(value) {
        this.$emit('input', value);
    }

    public onConfirmDelete() {
        this.$emit('onConfirmDelete');
    }
}
